// A rate's percentage can carry decimals so its price lands on an exact amount
// (8 paid hours out of 11 is 27.27...%), but guests are shown whole percents,
// the same way the checkout's discount labels and the daily saving read.
export function formatSavingPercent(adjustmentValue: number): string {
  return `${Math.round(Math.abs(adjustmentValue))}%`;
}
